import React from "react";
import Divider from '@mui/material/Divider';
import InwaterResearchGroupStudies from '../Images/Inwater-Research-Group-Studies-Green-Turtles-at-the-Jupiter-Inlet.jpg'
import InwaterResearchGroupStudies2 from '../Images/Inwater-Research-Group-Studies-Green-Turtles-at-the-Jupiter-Inlet-2.jpg'

export default function InwaterJupiter() {
  return (
    <div className='bg-white p-20 '>
      <div><div className='pb-5'><h1 className='text-2xl font-bold text-[#F27920]'>Inwater Research Group Studies Green Turtles at the Jupiter Inlet</h1></div></div>

      <Divider className='' />
      <div className="mt-5">
        <img className="rounded-2xl mx-auto" src={InwaterResearchGroupStudies} alt="" title="" />
      </div>
      <div className="mt-5">
        <img className="rounded-2xl mx-auto" src={InwaterResearchGroupStudies2} alt="" title="" />
      </div>
    </div>
  );
}
